import { getBaseUrl } from "@/helpers/getBaseUrl"

export type DeliveryLinkItem = {
  application: string
  approvalUid: string
}

export type DeliveryData = {
  company: string
  companyAddress: string
  items: DeliveryLinkItem[]
}

export const mapApprovalItemsToDeliveryData = (
  items: Maybe<ApprovalEntity>[] | null | undefined
): DeliveryData => {
  const approvalItems = (items ?? []).filter((item): item is ApprovalEntity => !!item)
  const firstItem = approvalItems[0]

  return {
    company: firstItem?.attributes?.company?.data?.attributes?.name || "",
    companyAddress: firstItem?.attributes?.company?.data?.attributes?.address || "",
    items: approvalItems
      .map(item => ({
        application: item.attributes?.application?.data?.attributes?.title || "",
        approvalUid: item.attributes?.uuid || "",
      }))
      .filter(item => item.approvalUid),
  }
}

export const createDeliveryLink = ({
  organization,
  company,
  companyAddress,
  items,
}: {
  organization: string
  company: string
  companyAddress: string
  items: DeliveryLinkItem[]
}): string => {
  const params = new URLSearchParams({
    "delivery-confirmation": "true",
    company,
    companyAddress,
  })

  items.forEach(item => {
    params.append("application", item.application)
    params.append("approvalUid", item.approvalUid)
  })

  const baseUrl = getBaseUrl()

  return `${baseUrl}/${organization}/home?${params.toString()}`
}

export const parseDeliveryLinkParams = (searchParams: URLSearchParams): DeliveryData => {
  const approvalUids = searchParams.getAll("approvalUid")
  const applications = searchParams.getAll("application")

  return {
    company: searchParams.get("company") || "",
    companyAddress: searchParams.get("companyAddress") || "",
    items: approvalUids.map((approvalUid, index) => ({
      application: applications[index] || "",
      approvalUid,
    })),
  }
}
